import React, { FC } from 'react';
import { Wrapper } from './styles';
import { SideMenu, SubscribersList } from 'features';

const MySubscribersPage: FC = () => {
  return (
    <Wrapper>
      <SideMenu />
      <SubscribersList />
    </Wrapper>
  );
};

export default MySubscribersPage;
